import styled from 'styled-components';

export { StyledTabs, StyledTab } from 'components/Tabs/styles';

export const CommentItem = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  border-radius: 4px;
  margin: 8px;
  padding: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[100]};
    border: 1px solid ${({ theme }) => theme.palette.primary.main};
  }
`;

export const CommentContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const CommentPrimary = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  justify-content: space-between;
`;

export const CommentText = styled.span`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  margin: 0;
  margin-top: 4px;
`;

export const CommentMeta = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
  margin: 0;
`;

export const CommentActions = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  margin-left: 8px;
`;

export const CommentAuthor = styled.span`
  color: ${({ theme }) => theme.palette.text.primary};
  margin: 0;
  font-size: 16px;
  letter-spacing: 0.15px;
  overflow-wrap: anywhere;
  min-width: 0;
`;

export const CommentReplies = styled.p`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 12px;
  margin: 0;
`;

export const CommentCardContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 10px;
`;

export const ThreadComposerContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
`;

export const CommentEditorSurface = styled.div`
  flex: 1;
  min-width: 0;

  .ProseMirror {
    border: 1px solid ${({ theme }) => theme.palette.grey[300]};
    border-radius: 4px;
    padding: 8px;
    font-size: 14px;
    min-height: 36px;
    max-height: 160px;
    overflow-y: auto;
    outline: none;

    &:focus {
      border-color: ${({ theme }) => theme.palette.primary.main};
    }

    p {
      margin: 0;
    }

    p.is-editor-empty:first-child::before {
      content: attr(data-placeholder);
      color: ${({ theme }) => theme.palette.text.secondary};
      float: left;
      height: 0;
      pointer-events: none;
    }

    .mention {
      color: ${({ theme }) => theme.palette.primary.main};
      background: ${({ theme }) => theme.tint.primary.light};
      border-radius: 4px;
      padding: 0 4px;
      white-space: nowrap;
    }
  }
`;

export const CommentEditActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 8px;
`;

export const CommentReadSurface = styled.div`
  .ProseMirror {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 14px;
    margin-top: 4px;
    outline: none;

    p {
      margin: 0;
    }

    .mention {
      color: ${({ theme }) => theme.palette.primary.main};
      background: ${({ theme }) => theme.tint.primary.light};
      border-radius: 4px;
      padding: 0 4px;
      white-space: nowrap;
    }
  }
`;
